if(!customElements.get('gh-watch-anatomy')){
  customElements.define('gh-watch-anatomy',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      this.chapters=[...this.querySelectorAll('[data-wa-chapter]')];
      this.parts=[...this.querySelectorAll('[data-wa-part]')];
      this.buttons=[...this.querySelectorAll('.gh-wa__navigation [data-wa-goto]')];
      this.assembly=this.querySelector('.gh-wa__assembly');
      this.scene=this.querySelector('.gh-wa__scene');
      this.label=this.querySelector('[data-wa-label]');
      this.progress=this.querySelector('.gh-wa__nav-progress');
      this.count=this.querySelector('[data-wa-count]');
      this.announcement=this.querySelector('[data-wa-announcement]');
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.steps=this.chapters.length-1;
      this.setAttribute('data-active-step','0');
      this.active=-1;this.current=0;this.target=0;this.visible=true;
      this.chapters[0].classList.add('is-active');
      this.classList.add('is-ready');
      this.measure();
      const opts={signal:this.controller.signal};
      this.addEventListener('click',e=>{
        const button=e.target.closest('[data-wa-goto]');if(!button)return;
        const step=Number(button.dataset.waGoto);
        const rect=this.getBoundingClientRect();
        const landing=step===0?0:this.coverHold+(step-1)*this.cycle+this.transitionSpan+this.holdSpan/2;
        window.scrollTo({top:window.scrollY+rect.top+landing*this.scrollUnit,behavior:this.motion.matches?'auto':'smooth'});
      },opts);
      window.addEventListener('scroll',()=>this.schedule(),{...opts,passive:true});
      window.addEventListener('resize',()=>{this.measure();this.schedule();},opts);
      this.motion.addEventListener('change',()=>this.schedule(),opts);
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible)this.schedule();},{rootMargin:'100px'});
      this.observer.observe(this);
      this.schedule();
    }
    measure(){
      this.pinnedHeight=Math.max(640,window.innerHeight);
      this.scrollUnit=Math.max(640,window.innerHeight);
      this.coverHold=.3;this.transitionSpan=.55;this.holdSpan=1.05;
      this.cycle=this.transitionSpan+this.holdSpan;
      this.style.height=(this.pinnedHeight+(this.coverHold+this.steps*this.cycle)*this.scrollUnit)+'px';
      this.unit=this.scene.getBoundingClientRect().width/400;
    }
    schedule(){if(!this.frame && this.visible)this.frame=requestAnimationFrame(()=>this.update());}
    mix(a,b,t){return a+(b-a)*t;}
    state(step){
      const base={strap:[0,0,-9,1,1],back:[0,0,-24,1,1],movement:[0,0,-12,1,1],case:[0,0,0,1,1],dial:[0,0,12,1,1],hands:[0,0,17,1,1],crystal:[0,0,21,1,.8],crown:[0,0,2,1,1]};
      if(step===0)return{tilt:29,angle:-22,parts:base};
      const spread=Math.min(1,.64+step*.07);
      const p={strap:[0,0,-16,1,.42],back:[0,0,-220*spread,1,.8],movement:[18,0,-115*spread,1,.9],case:[0,0,0,1,1],dial:[-15,0,110*spread,1,.95],hands:[8,0,190*spread,1,1],crystal:[-22,0,290*spread,1,1],crown:[100*spread,0,0,1,1]};
      const focus=this.chapters[step]?.dataset.waComponent;
      if(focus==='case'){p.case[0]=-45;p.case[2]=20;p.dial[0]=25;}
      if(focus==='crown'){p.crown[0]=165;p.crown[2]=40;}
      if(focus==='dial'){p.dial[0]=-25;p.dial[2]=120;p.hands[2]=205;}
      if(focus==='movement'){p.movement[2]=-10;p.movement[0]=0;p.dial[0]=-125;p.dial[2]=155;p.hands[0]=-105;p.hands[2]=235;p.crystal[0]=-85;p.crystal[2]=310;p.back[2]=-200;}
      if(focus==='back'){p.back[0]=-50;p.back[2]=-210;p.movement[0]=70;}

      for(const [key,value] of Object.entries(p))value[4]=(key===focus || (focus==='dial' && key==='hands'))?1:.025;
      return{tilt:focus==='movement'?49:58,angle:focus==='crown'?-17:-27,parts:p};
    }
    update(){
      this.frame=0;
      const rect=this.getBoundingClientRect();
      const track=Math.max(0,-rect.top/this.scrollUnit-this.coverHold);
      const segment=Math.min(this.steps-1,Math.floor(track/this.cycle));
      const within=track-segment*this.cycle;
      this.target=Math.min(this.steps,segment+Math.min(1,within/this.transitionSpan));
      this.current=this.motion.matches?Math.round(this.target):this.mix(this.current,this.target,.2);
      if(Math.abs(this.current-this.target)<.002)this.current=this.target;
      const a=Math.floor(this.current),b=Math.min(this.steps,a+1),fraction=this.current-a;
      const ease=fraction*fraction*(3-2*fraction),from=this.state(a),to=this.state(b);
      const reveal=Math.pow(Math.sin(Math.PI*fraction),4);
      this.assembly.style.transform='rotateX('+this.mix(from.tilt,to.tilt,ease)+'deg) rotateZ('+this.mix(from.angle,to.angle,ease)+'deg)';
      for(const part of this.parts){
        const key=part.dataset.waPart,start=from.parts[key],end=to.parts[key];
        const v=start.map((x,i)=>this.mix(x,end[i],ease));
        part.style.transform='translate3d('+v[0]*this.unit+'px,'+v[1]*this.unit+'px,'+v[2]*this.unit+'px) scale('+v[3]+')';
        part.style.opacity=this.mix(v[4],1,reveal);
      }
      this.progress.style.transform='scaleX('+this.current/this.steps+')';
      const active=Math.min(this.steps,Math.round(this.current));
      if(active!==this.active){
        this.active=active;this.setAttribute('data-active-step',String(active));
        this.chapters.forEach((chapter,i)=>{chapter.classList.toggle('is-active',i===active);chapter.setAttribute('aria-hidden',String(i!==active));});
        this.buttons.forEach((button,i)=>{if(i===active)button.setAttribute('aria-current','step');else button.removeAttribute('aria-current');});
        this.count.textContent=String(active+1).padStart(2,'0')+' / '+String(this.steps+1).padStart(2,'0');
        const heading=this.chapters[active].querySelector('h1,h2').textContent;
        this.announcement.textContent=heading;
        this.label.querySelector('span').textContent=active?this.buttons[active].textContent:'';
        this.label.style.opacity=active?'1':'0';
      }
      if(this.current!==this.target)this.schedule();
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.observer?.disconnect();cancelAnimationFrame(this.frame);}
  });
}
